// Frozen action keys emitted by CmlPopupActionBar. Constants, not magic strings,
// so the bar and the card agree on names (CLAUDE.md "Use Constants Not Magic Strings").
export const POPUP_ACTION = Object.freeze({
  VIEW_READINGS: 'view-readings',
  SHOW_IN_OTHER_VIEWER: 'show-in-other-viewer',
  OPEN_DOCUMENTS: 'open-documents',
  CREATE_TASK: 'create-task',
  LINK_TASK: 'link-task',
});
